// console.log('components');
import './components/sliders.js';
import './components/counter.js';
import './components/select.js';
import './components/mix.js';
import './components/form-validate';
import './components/modal';